import React from 'react';
import classNames from 'classnames';

import css from './IconAccordion.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconAccordion = props => {
  const { className, rootClassName, closed = false } = props;
  const classes = classNames(rootClassName || css.root, className);

  return closed ? <svg className={classes} width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 15L8.5 8L1.5 1" stroke="#6E7191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg> : <svg className={classes} width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8L8 1L1 8" stroke="#6E7191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>;
};

export default IconAccordion;
